import { render } from "./SecuritiesFum.vue?vue&type=template&id=3d9499a4&scoped=true&ts=true"
import script from "./SecuritiesFum.vue?vue&type=script&lang=ts"
export * from "./SecuritiesFum.vue?vue&type=script&lang=ts"

import "./SecuritiesFum.vue?vue&type=style&index=0&id=3d9499a4&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9499a4"]])

export default __exports__